var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1771 20.2928C11.2321 20.6922 11.5795 21 11.9999 21C12.4585 21 12.8302 20.6337 12.8302 20.1818L12.8302 5.80007L18.0813 10.9953L18.1743 11.0747C18.4989 11.313 18.9602 11.2876 19.2556 10.9977C19.5805 10.6788 19.5816 10.1608 19.258 9.84062L12.5996 3.25226C12.5614 3.21304 12.5194 3.17756 12.474 3.14642C12.1498 2.92336 11.6999 2.95478 11.4111 3.24067L4.74193 9.84067L4.66174 9.9326C4.42125 10.2534 4.44905 10.7079 4.74446 10.9977C5.06942 11.3166 5.59515 11.3155 5.91871 10.9953L11.1696 5.79877L11.1696 20.1818L11.1771 20.2928Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpWhite);
export default __webpack_public_path__ + "static/media/arrowUpWhite.dc4d0ae821abba0377e6b40772d65f42.svg";
export { ForwardRef as ReactComponent };